import { makeAutoObservable } from 'mobx'
import ExtendedMap from 'src/models/ExtendedMap'

import { LevelSetting } from './LevelSetting'

export class LevelSettingColl {
  map: ExtendedMap<'veryLow' | 'low' | 'middle' | 'high' | 'veryHigh', LevelSetting>
  constructor(map: ExtendedMap<'veryLow' | 'low' | 'middle' | 'high' | 'veryHigh', LevelSetting>) {
    makeAutoObservable(this)
    this.map = map
  }

  get toArr() {
    return [...this.map.values()]
  }

  get isAllValid() {
    return this.toArr.every(({ isValid }) => isValid)
  }

  setLevel(key: number, value: [number, number, number, number, number]) {
    this.toArr[key].difficultySetting = value
  }

  get(key: LevelSetting['key']) {
    return this.map.get(key)
  }
}
